import { SvgIconProps } from './icon-props';

export default function CloseAlt({ height = 20, width = 20, fill = '#000000' }: SvgIconProps) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 20 21"
			fill="none"
			style={{ flexShrink: 0 }}
		>
			<path
				d="M16.25 4.81055L15.75 4.31055L10 10.0605L4.25 4.31055L3.75 4.81055L9.5 10.5605L3.75 16.3105L4.25 16.8105L10 11.0605L15.75 16.8105L16.25 16.3105L10.5006 10.5605L16.25 4.81055Z"
				fill={fill}
			/>
		</svg>
	);
}
